import * as R from "ramda";
const sortWithName = R.sortWith([R.ascend(R.prop("name"))]);
export { sortWithName };
